import { cn } from "@awtoban/ui";
import { useTranslation } from "react-i18next";
import { type Locale, setStoredLocale } from ".";

const LOCALES: { code: Locale; label: string }[] = [
  { code: "tk", label: "TK" },
  { code: "ru", label: "RU" },
  { code: "en", label: "EN" },
];

export function LocaleSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language as Locale;

  return (
    <div className="inline-flex overflow-hidden rounded-md border border-line-strong bg-paper text-sm">
      {LOCALES.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => {
            setStoredLocale(l.code);
            void i18n.changeLanguage(l.code);
          }}
          className={cn(
            "px-2.5 py-1.5 font-medium tracking-wider transition-colors",
            "focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-ink",
            current === l.code
              ? "bg-ink text-paper"
              : "text-ink-muted hover:bg-paper-soft hover:text-ink",
          )}
          aria-pressed={current === l.code}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
